/**
 * api接口的统一出口
 */
import '../utils/global.js'//引入全局变量
// 账户接口
import account from './account';
// 登陆注册接口
import user from './user';
// 实例接口
import instance from './instance';
// 报警联系人接口
import contact from './contact';
// 邮件模板接口
import briefReport from './briefReport';
// 案例模板接口
import ticket from './ticket';
// 评论模板接口
import comment from './comment';
// 公司模板接口
import company from './company';
// 附件模板接口
import attatchment from './attatchment';
// file模板接口
import file from './file';
// volume模板接口
import volume from './volume';
// alertRule模板接口
import alertRule from './alertRule';
// systemTask模板接口
import systemTask from './systemTask';
// billing模板接口
import billing from './billing';
// security模块接口
import security from './security';
//auditTask 接口
import auditTask from './auditTask';
// 日程接口
import schedule from './schedule';
// 数据库接口
import rds from './rds';
// 默认报警配置接口
import customerDefinedAlarmConfiguration from './customerDefinedAlarmConfiguration'
// 太古实例列表接口
import swireOpsInstance from './swireOpsInstance'
// 组接口
import group from './group'
// 组数据库关联表接口
import groupDatabaseRelation from "./groupDatabaseRelation";
// 组实例关联表接口
import groupInstanceRelation from "./groupInstanceRelation";
// 组卷关联表接口
import groupVolumeRelation from "./groupVolumeRelation";
// 组用户关联接口
import groupUserRelation from "./groupUserRelation";
// cloudwatch关联接口
import cloudWatch from "./cloudWatch";
// brokerSummary关联接口
import brokerSummary from "./brokerSummary";
//instrumentPanel接口
import instrumentPanel from "./instrumentPanel";
// bucket关联接口
import bucket from "./bucket";
// log关联接口
import log from "./log";
// cen关联接口
import cen from "./cen";
// cen关联接口
import loadBalancer from "./loadBalancer";
// billingRI关联接口
import billingRI from "./billingRI";
// swireBilling关联接口
import swireBilling from "./swireBilling";
// policy关联接口
import policy from "./policy";
// actionTrail关联接口
import actionTrail from "./actionTrail";
// scheduleManagement关联接口
import scheduleManagement from "./scheduleManagement";
// patchCommandProperty接口
import patchCommandProperty from "./patchCommandProperty";
// accountGroup接口
import accountGroup from "./accountGroup";
//groupAccountRelation
import groupAccountRelation from "./groupAccountRelation";
//alertRuleConfiguration
import alertRuleConfiguration from "./alertRuleConfiguration";
//resourceManagement
import resourceManagement from "./resourceManagement";
// cloudTrail
import cloudTrail from "./cloudTrail";
// silverliningEBilling
import silverliningEBilling from "./silverliningEBilling";
// agw
import agw from "./agw";
// aiMonitor
import aiMonitor from "./aiMonitor";
// applicationDatabaseRelation
import applicationDatabaseRelation from "./applicationDatabaseRelation";
// applicationInstanceRelation
import applicationInstanceRelation from "./applicationInstanceRelation";
// aiForecastDataPoint
import aiForecastDataPoint from "./aiForecastDataPoint";
// aiApplicationAlert
import aiApplicationAlert from "./aiApplicationAlert";
// resourceAzureAppService
import resourceAzureAppService from "./resourceAzureAppService";
// resourceSecurityLogConfiguration
import resourceSecurityLogConfiguration from "./resourceSecurityLogConfiguration";
// redshift
import redshift from "./redshift";
// 腾讯云监控
import tencentMonitor from "./tencentMonitor";
// 虚拟桌面
import workspace from "./workspace";
// groupWorkspaceRelation
import groupWorkspaceRelation from "./groupWorkspaceRelation";
// 运维值班管理
import kpiShift from "./kpiShift";
// elasticsearch
import elasticsearch from "./elasticsearch";
// 加班管理
import kpiOvertimeRecordByUser from "./kpiOvertimeRecordByUser";
// kpi 附件管理
import kpiOvertimeRecordByYearMonth from "./kpiOvertimeRecordByYearMonth";
// 节点模块
import processNode from "./processNode";
// 审批流模块
import processTemplate from "./processTemplate";
// 审批任务
import processTask from "./processTask";
// 流程节点
import processOperationLog from "./processOperationLog";
// 自动化运维报告
import report from "./report";
// 财务优化
import reportReservedInstance from "./reportReservedInstance";
// 资源优化
import reportOptimize from "./reportOptimize";
// 运维工作
import reportTicket from "./reportTicket";
// 重大事件
import reportEvent from "./reportEvent";
// 报警规则日志查询
import alertRuleOperationLog from "./alertRuleOperationLog";
// 预留实例
import reservedInstance from "./reservedInstance";
// 菜单管理
import menu from "./menu";
// trustedAdvisor
import trustedAdvisor from "./trustedAdvisor";
// 联系人组
import contactGroup from "./contactGroup";
// 未挂载资源
import resourceNotAttached from "./resourceNotAttached";
// 标签同步
import tag from "./tag";
// project
import project from "./project";
// price
import price from "./price";
//资源生命周期
import lifecycleResourceApplication from "./lifecycleResourceApplication";
//AWS 价格
import awsPrice from "./awsPrice";
//Azure 价格
import azurePrice from "./azurePrice";
// lifecycleResourcePriceAdjustment
import lifecycleResourcePriceAdjustment from "./lifecycleResourcePriceAdjustment";
// bill
import bill from "./bill";
// 例外资源
import alertRuleExceptionResource from "./alertRuleExceptionResource";
// 合规检查
import awsConfigCheckItem from "./awsConfigCheckItem";
import noncompliantResourcesIgnored from "./noncompliantResourcesIgnored";
// 云用户
import resourceCloudUser from "./resourceCloudUser";
// 邮箱
import mailbox from "./mailbox";
// 事件
import event from "./event";
//还原
import environmentalRestoration from "./environmentalRestoration";
// 微信
import userWeChat from "./userWeChat";
//电话
import userPhone from "./userPhone";
//预留实例
import awsReservationStatistics from "./awsReservationStatistics"
// 获取微信二维码
import callWechatServer from "./callWechatServer";
// 预留实例配置
import purchaseRiFamilySize from "./purchaseRiFamilySize";
// 返回上级节点
import resourceReservedInstanceApprovalRecord from "./resourceReservedInstanceApprovalRecord";
// 配置管理操作日志
import configurationManagementOperationLog from "./configurationManagementOperationLog";
// 预留实例标签
import reservedInstanceTag from "./reservedInstanceTag";
// AWS存储网关
import storageGateway from "./storageGateway";
// AWS 存储网关组关联
import groupStorageGatewayRelation from "./groupStorageGatewayRelation";
import standardTagRule from "./standardTagRule";
// 标签监控
import resourceTagWarning from "./resourceTagWarning";
// 网站健康状态检查
import websiteInfo from "./websiteInfo";
// 企业微信机器人
import enterpriseWechatRobot from "./enterpriseWechatRobot";
//企业微信机器人操作日志
import enterpriseWechatRobotOperationLog from "./enterpriseWechatRobotOperationLog";
// Redis
import awsCache from "./awsCache";
// adminGroupResourceAwsCacheRelationship
import adminGroupResourceAwsCacheRelationship from "./adminGroupResourceAwsCacheRelationship";
// reservedInstanceTagRelationship
import reservedInstanceTagRelationship from "./reservedInstanceTagRelationship";
// 成本分摊
import apportion from "./apportion";
// 成本中心
import apportionCostCenter from "./apportionCostCenter";
import apportionApplication from "./apportionApplication";
// 标签纠正
import correctStandardTagValueConfiguration from "./correctStandardTagValueConfiguration";
// 资源优化
import resourceOptimize from "./resourceOptimize";
// GCP折扣
import gcpDiscount from "./gcpDiscount";
//cud推荐
import cudRecommend from './cudRecommend';
//eip模块接口
import eip from "./eip";
//nat模块接口
import nat from "./nat";
//弹性伸缩接口
import autoscaling from "./autoscaling"
//RDS PI 数据库
import performance from "./performance";
//web应用防火墙接口
import webApplicationFirewall from "./webApplicationFirewall"
//备份计划接口
import resourceAwsBackupPlan from "./resourceAwsBackupPlan"
// DocDB接口
import DocDB from './DocDB.js';

// 资源权限接口
import resourcePermis from './resourcePermis'
import originalBillEntry from './originalBillEntry'

// cmdb接口
import cmdb from './cmdb'

// 任务调度中心
import taskScheduler from './taskScheduler'

// AI 可用性面板
import aiAvailability from './aiAvailability'

// 导出接口
export default {
  user,
  account,
  instance,
  contact,
  briefReport,
  ticket,
  comment,
  company,
  attatchment,
  file,
  volume,
  instrumentPanel,
  alertRule,
  systemTask,
  billing,
  security,
  auditTask,
  schedule,
  rds,
  customerDefinedAlarmConfiguration,
  swireOpsInstance,
  group,
  groupDatabaseRelation,
  groupInstanceRelation,
  groupVolumeRelation,
  groupUserRelation,
  groupStorageGatewayRelation,
  cloudWatch,
  brokerSummary,
  bucket,
  log,
  cen,
  loadBalancer,
  billingRI,
  swireBilling,
  policy,
  actionTrail,
  scheduleManagement,
  patchCommandProperty,
  accountGroup,
  groupAccountRelation,
  alertRuleConfiguration,
  resourceManagement,
  cloudTrail,
  silverliningEBilling,
  agw,
  aiMonitor,
  applicationDatabaseRelation,
  applicationInstanceRelation,
  aiForecastDataPoint,
  aiApplicationAlert,
  resourceAzureAppService,
  resourceSecurityLogConfiguration,
  redshift,
  tencentMonitor,
  workspace,
  groupWorkspaceRelation,
  kpiShift,
  elasticsearch,
  kpiOvertimeRecordByUser,
  kpiOvertimeRecordByYearMonth,
  processNode,
  processTemplate,
  processTask,
  processOperationLog,
  report,
  reportReservedInstance,
  reportOptimize,
  reportTicket,
  reportEvent,
  alertRuleOperationLog,
  reservedInstance,
  menu,
  trustedAdvisor,
  contactGroup,
  resourceNotAttached,
  tag,
  project,
  price,
  lifecycleResourceApplication,
  awsPrice,
  azurePrice,
  lifecycleResourcePriceAdjustment,
  bill,
  alertRuleExceptionResource,
  awsConfigCheckItem,
  noncompliantResourcesIgnored,
  resourceCloudUser,
  environmentalRestoration,
  mailbox,
  event,
  userWeChat,
  userPhone,
  awsReservationStatistics,
  callWechatServer,
  purchaseRiFamilySize,
  resourceReservedInstanceApprovalRecord,
  configurationManagementOperationLog,
  reservedInstanceTag,
  storageGateway,
  standardTagRule,
  resourceTagWarning,
  websiteInfo,
  enterpriseWechatRobot,
  enterpriseWechatRobotOperationLog,
  awsCache,
  adminGroupResourceAwsCacheRelationship,
  reservedInstanceTagRelationship,
  apportion,
  apportionCostCenter,
  apportionApplication,
  correctStandardTagValueConfiguration,
  resourceOptimize,
  cudRecommend,
  eip,
  gcpDiscount,
  nat,
  autoscaling,
  performance,
  webApplicationFirewall,
  resourceAwsBackupPlan,
  DocDB,
  resourcePermis,
  originalBillEntry,
  cmdb,
  taskScheduler,
  aiAvailability
}



// WEBPACK FOOTER //
// ./src/api/index.js